

<div [class.rtl]="lang == 'ar'" class="export-staff-modal">
    <div class="modal-body">
        <div class="file-type-wrapper mb-2">
            <label>{{'staff-export-modal.file-type.title'|translate}}</label>
            <p-dropdown *ngIf="fileTypes.length" [options]="fileTypes"
                [(ngModel)]="selectedFileType"></p-dropdown>
        </div>
        <div class="role-type-wrapper" *ngIf="selectedFileType == 'excel'">
            <label>{{'staff-export-modal.role-type.title'|translate}}</label>
                <p-multiSelect #multiSelectStaffExport [options]="roles"
                [(ngModel)]="selectedRoles" (onChange)="primeSelectChanged($event)"
                defaultLabel="{{'staff-export-modal.role-type.default' | translate}}"
                emptyFilterMessage="{{'staff-export-modal.role-type.empty-filter' | translate}}"></p-multiSelect>
                <div class="empty-error" *ngIf="showEmptyRoleError">
                    {{'staff-export-modal.role-type.no-roles-selected' | translate}}
                </div>
        </div>
    </div>
    <div class="footer">
        <button class="act-btn close-btn" (click)="closeModal()">{{'staff-export-modal.cancel'|translate}}</button>
        <button class="act-btn generate-btn" (click)="generateFile()" [ngClass]="{'generate-btn-disabled': selectedRoles.length == 0 && selectedFileType == 'excel'}">{{'staff-export-modal.generate'|translate}}</button>
    </div>
</div>